module.exports = __webpack_public_path__ + "static/sayflowers_w-f9dbf53a0da7d78465de3ec430a1dfb3.svg";